
import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';

import { ITheme, IThemeService } from '../models';

@Injectable({
	providedIn: 'root'
})
export class DummyThemeService implements IThemeService {

	public current$: Observable<string> = EMPTY;

	install(...themes: ITheme[]) {
		console.log('[themes] install', ...themes)
	}

	useTheme(theme: string) {
		console.log('[themes] use', theme)
	}
}
